<template>
  <div class="site-footer">
    <div class="nav-footer">
      <ul class="menu">
        <li class="menu-item"><a :href="$utils.getWpPath('')">หน้าแรก</a></li>
        <!-- <li class="menu-item"><a :href="$utils.getWpPath('phapaforeducation')">แคมเปญ</a></li> -->
        <li class="menu-item"><a :href="$utils.getWpPath('our-work')">งานของเรา</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('about')">เกี่ยวกับเรา</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('good-governance')">ธรรมาภิบาล</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('news-media')">ข่าวสาร</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('take-action')">ร่วมร้อยพลัง</a></li>
        <!-- <li class="menu-item"><a :href="$utils.getWpPath('faq')">ถาม-ตอบ</a></li> -->
      </ul>
    </div>
    <div class="bottom-footer">
      <div class="container">
      <div class="col">
        <img class="fl-left logo-footer"
          src="../assets/domain-custom/base/logo-domain.png"
          :srcset="`${require('../assets/domain-custom/base/logo-domain.png')} 1x, ${require('../assets/domain-custom/base/logo-domain@2x.png')} 2x`" alt="LOGO TCFE" />
        <div class="">
          <strong>ติดต่อ – สอบถามข้อมูลเพิ่มเติม</strong><br>
          โครงการร้อยพลังเปลี่ยนประเทศ มูลนิธิเพื่อคนไทย<br>
          อีเมล: tcfe@ktf.premier.co.th<br>
          โทรศัพท์: 02 301 1000 ต่อ 1117 / 02 301 1117
        </div>
      </div>
      <div class="col">
        <div class="social-footer">
        <div style="margin-bottom: 10px;"><strong>สอบถามรายละเอียด หรือรับข่าวสารผ่านช่องทางของเรา</strong></div>
        <div style="display: flex;"><div style="flex:1; margin-right: 10px; text-align: center;"><a href="http://line.me/ti/p/%40TCFE"><img class="wp-image-1436 alignnone" style="margin-bottom: 0 !important;" src="../assets/img/icon/line-add@2x.png" alt="" width="196" height="53" /><span style="text-align: center; display: inline-block; font-size: 13px;">LINE ID: @TCFE</span></a></div><div style="flex:1;"><a href="https://web.facebook.com/ThailandCollaborationForEducation/" target="blank"><img class="wp-image-1434 alignnone" src="../assets/img/icon/facebook-page@2x.png" alt="" width="196" height="53" /></a></div></div>
        </div>
      </div>
    </div>
    </div> <!-- /bottom Footer -->


  </div>
</template>

<script>
  export default {
    name: 'SiteFooter'
  }
</script>

<style scoped lang="scss">

.site-footer {
  background: #fff;
}

.nav-footer {
  padding: 10px;
  background: #F7941D;
  font-size: 17px;
  line-height: 1.5em;
  > .menu {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: center;
    overflow: hidden;
    > .menu-item {
      margin: 0 15px;
      display: inline-block;
      padding: 0;
      a {
        color: #fff;
        transition: all 0.3s ease 0s;
        &:hover, &.router-link-active {
          text-decoration: none;
          color: #3F3F3F
        }
      }
    }
  }
}

.bottom-footer .container{
  padding: 40px 15px;
  font-size: 0.9em;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  > .col {
    flex-grow: 1;
  }
}
.logo-footer {
  margin-right: 20px;
  @media all and (max-width: 1024px) and (min-width: 768px) {
    margin-bottom: 10px;
    float: none;
    display: block;
  }
}
.social-list {
  float: right;
  list-style: none;
  padding: 0;
  margin: 0;
  > .social-item {
    display: inline-block;
    a {
      font-size: 25px;
      padding: 8px 10px;
      border-radius: 2px;
      background: #f7dfcf;
      color: #f8941d;
      line-height: 1.2em;
      text-align: center;
      display: inline-block;
      transition: all 0.3s ease 0s;
      &:hover {
        background: #f8941d;
        color: #ffffff;
        text-decoration: none;
      }
    }
  }
}
/* Footer Social Media*/
.social-footer {
  max-width: 400px;
  float: right;
}
.social-footer a {
	color: #525252;
}
@media (max-width: 768px) {
  .social-footer {
    float: none;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// SiteFooter.vue?ba0b77e8